import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex, Truncate, getPaletteColor } from 'pcln-design-system'
import { BookmarkActivated } from 'pcln-icons'

const TileWrapper = styled(Flex)`
  border: 1px solid ${getPaletteColor('border.base')};
  border-radius: ${(props) => props.theme.borderRadii.lg};
  cursor: pointer;
`

const RadioInput = styled.input`
  appearance: none;
  opacity: 0;
  position: absolute;
  z-index: 0;
  &:focus,
  &:active,
  &:hover,
  &:checked {
    & ~ ${TileWrapper} {
      border-color: ${getPaletteColor('primary.base')};
    }
  }

  &:focus,
  &:active {
    & ~ ${TileWrapper} {
      outline: ${getPaletteColor('primary.base')} auto 1px;
    }
  }
  &:checked {
    & ~ ${TileWrapper} {
      background-color: ${getPaletteColor('primary.light')};
    }
  }
  &:disabled {
    & ~ ${TileWrapper} {
      background-color: ${getPaletteColor('background.base')};
      border-color: ${getPaletteColor('background.base')};
      pointer: none;
    }
  }
`

const TrucatedLabel = styled(Truncate)`
  white-space: normal;
`

const Tile = ({ className, checked, dataAutobotElementId, disabled, icon, id, label, value }) => {
  const [isChecked, setChecked] = useState(checked)

  useEffect(() => {
    setChecked(checked)
  }, [checked])

  return (
    <label className={className} htmlFor={id}>
      <RadioInput
        id={id}
        data-testid='Tile'
        type='checkbox'
        disabled={disabled}
        checked={isChecked}
        value={value}
        onChange={() => setChecked(!isChecked)}
        data-autobot-element-id={dataAutobotElementId}
      />
      <TileWrapper
        width={1}
        py={2}
        px='12px'
        color='background.lightest'
        flexDirection='column'
        textAlign='left'
        height='100%'
      >
        <Flex width={1}>
          <TrucatedLabel
            as='span'
            fontSize={1}
            fontWeight='bold'
            color={disabled ? 'text.light' : 'primary.dark'}
            maxWidth='calc(100% - 20px)'
            title={label}
          >
            {label}
          </TrucatedLabel>
          {icon &&
            React.cloneElement(icon, {
              color: disabled ? 'text.light' : 'primary',
              ml: 'auto',
              size: '20px',
            })}
        </Flex>
      </TileWrapper>
    </label>
  )
}

Tile.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  dataAutobotElementId: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
}

Tile.defaultProps = {
  label: 'Theme',
  icon: <BookmarkActivated />,
}

export default Tile
